import api from './api';

const adminColorsService = {
  async getColors() {
    const res = await api.get('/admin/colors');
    return res.data.colors;
  },
  async addColor(color) {
    const res = await api.post('/admin/colors', color);
    return res.data;
  },
  async updateColor(id, color) {
    const res = await api.put(`/admin/colors/${id}`, color);
    return res.data;
  },
  async deleteColor(id) {
    const res = await api.delete(`/admin/colors/${id}`);
    return res.data;
  }
};

export default adminColorsService;
